<button
  data-cy="open-loaded-image"
  type="button"
  class="relative flex justify-center items-center rounded-7 overflow-hidden cursor-default h-48 w-48"
  [ngClass]="{ 'cursor-pointer': isLoaded }"
>
  <img *ngIf="base64 && !isDicom" src="{{ base64 }}" alt="" class="h-48 w-48" />
  <div *ngIf="!base64 || isDicom" class="h-48 w-48"></div>
  <span
    class="absolute left-0 top-0 w-full h-full bg-sidebar opacity-60 rounded-7 flex justify-center items-center"
  >
    <span *ngIf="isDicom" class="text-10 text-gray-300">Dicom</span>
  </span>
  <tdv-icon-goal-wrap
    *ngIf="isLoaded"
    class="absolute-i top-16 left-16 w-16 h-16"
  >
    <tdv-icon name="search" class="w-14 h-14"></tdv-icon>
  </tdv-icon-goal-wrap>
</button>
